import { TodoType } from '../api';

type ListItemProps = {
  onClick: () => void;
} & TodoType;

export const ListItem = ({ id, isComplete, name, onClick }: ListItemProps) => (
  <div
    className={`p-2 rounded items-center justify-center ${
      isComplete ? 'bg-rose-200' : 'bg-emerald-200'
    }`}
  >
    <input
      id="default-checkbox"
      type="checkbox"
      value=""
      className=""
      checked={isComplete}
      onClick={onClick}
      readOnly
    />
    <label className={`text-black pl-2 ${isComplete ? 'line-through' : ''}`}>
      {name}
    </label>
  </div>
);
